<template>
  <div class="page">
    <van-notice-bar wrapable :scrollable="false">
      <ul style="font-size: 12px;">
        <li>申请提交后请耐心等待</li>
      </ul>
    </van-notice-bar>
    <template v-if="applyInfo.auditStatus==1 || applyInfo.auditStatus==2 ">
      <van-cell-group class="app-card">
        <div class="group-title">审核信息</div>
        <van-field class="readonly" label-align="left" :value="applyInfo.auditStatus | statusFilter" label="审核结果"
                   :readonly="true"/>
        <van-field v-model="applyInfo.auditRemark" :readonly="true" label="审核反馈信息" rows="3" autosize
                   type="textarea"/>
      </van-cell-group>
    </template>
    <van-cell-group class="app-card">
      <div class="group-title">工作证明-申请信息</div>
      <van-field class="readonly" label-align="left" v-model="applyInfo.personnelName" label="姓名"
                 placeholder="未录入" :readonly="true"/>
      <van-field class="readonly" v-model="applyInfo.personnelIdCard" :readonly="true" label="身份证号码"/>
      <van-field class="readonly" v-model="applyInfo.personnelCompanyName" :readonly="true" label="工作单位"
                 placeholder="未录入"/>
      <sys-dict class="readonly" v-model="applyInfo.personnelGender" dict-name='gender' :readonly="true" label="性别">
      </sys-dict>
      <van-field class="readonly" :value="applyInfo.personnelWorkStatus" :readonly="true" label="在职状态"/>
      <van-field class="readonly" :value="applyInfo.workStartDate" :readonly="true" label="派遣开始日期"/>
      <van-field class="readonly" :value="applyInfo.workEndDate" :readonly="true" label="派遣结束日期"/>
      <van-field :readonly="!canModify" v-model="applyInfo.textMessage" label="申请说明   （选填）" rows="3" autosize
                 maxlength="128"
                 show-word-limit
                 placeholder="请填写备注信息"
                 type="textarea"/>
      <div class="group-title"></div>
    </van-cell-group>
    <div style="margin-bottom: 60px;height: 1px;width: 100%;"></div>
    <div v-if="applyInfo.auditStatus!=1 && applyInfo.auditStatus!=2" class="fixed-bottom"
         style="background: #fff;display: flex;flex-direction: row;flex-wrap: nowrap; justify-content: space-around;">
      <van-button style="width: 80%;" type="info" round @click="handleClickSubmit(false)">提交申请</van-button>
    </div>
    <bind-personnel ref="bindPersonnel" @success="loadData"></bind-personnel>
  </div>
</template>

<script>
import BindPersonnel from '@/components/BindPersonnel'
import SysDict from '@/components/SysDict'
import Upload from '@/components/Upload'
import mixinLoad from '@/mixin/mixin-load.js'
import {
  checkService,
  userInfo as loadUserInfo
} from '@/api/user.js'
import {
  certWorkSubmit as submit,
  certWorkGet as getDetail
} from '@/api/cert'

export default {
  name: 'CertCenterWorkCreate',
  components: {
    SysDict,
    Upload,
    BindPersonnel,
  },
  mixins: [mixinLoad],
  filters: {
    businessTypeFilter: function (value) {
      return ['生产', '流产', '上环等计生手术'][value] || '';
    },
    statusFilter: function (value) {
      return ['草稿', '待审核', '审核通过', '审核不通过'][value] || '';
    }
  },
  computed: {
    canModify() {
      return this.applyInfo && this.applyInfo.auditStatus !== 1 && this.applyInfo.auditStatus !== 2
    }
  },
  data() {
    return {
      editId: null,
      userInfo: {},
      uploadParams: {
        fileType: 'img,file',
        subType: 'png,jpeg,jpg,pdf',
        fileMaxSize: '10240',
        checkFile: '0',
        serverCheck: '1',
        secrecyLevel: '1'
      },
      applyInfo: {
        companyAccountName: null,
        personnelCard: null,
        personnelName: null,
        personnelGender: null,
        marryCertificatesUrl: null,
        diagnosticCertificateUrl: null,
        birthMedicalCertificateUrl: null,
        birthRegistrationUrl: null,
        outpatientReceiptUrl: null,
        hospitalizationReceiptUrl: null,
        contactInformation: null,
        textMessage: null,
        businessType: 1,
        auditStatus: null,
        auditFeedbackPictureUrl: null,
        auditFeedbackText: null
      }
    }
  },
  methods: {
    loadData() {
      const loading = this.showLoading();
      if (this.editId) {
        getDetail(this.editId).then(({data}) => {
          this.applyInfo = data;
          loading.clear()
        }).catch(() => {
          loading.clear()
        })
      } else {
        loadUserInfo().then((rep) => {
          loading.clear()
          this.userInfo = rep.data;
          this.applyInfo.personnelName = this.userInfo.name;
          this.applyInfo.personnelIdCard = this.userInfo.idCard;
          this.applyInfo.personnelCompanyName = this.userInfo.companyName;
          this.applyInfo.personnelGender = this.userInfo.gender;
          this.applyInfo.workStartDate = this.userInfo.paiqianStartDate;
          this.applyInfo.workEndDate = this.userInfo.paiqianEndDate;
          this.applyInfo.personnelWorkStatus = this.userInfo.workStatus
          if (this.userInfo.workStatus === '在职' || this.userInfo.workStatus === '入职中') {
            this.applyInfo.workEndDate = "至今";
          }
        }).catch(() => {
          loading.clear()
        })
      }
    },
    handleClickSubmit() {
      this.$dialog.confirm({
        title: '提交',
        message: '是否确认提交申请？',
        confirmButtonText: '确定',
        cancelButtonText: '再想想'
      }).then(() => {
        const loading = this.showLoading();
        const {applyRemark} = this.applyInfo;
        submit({applyRemark}).then((rep) => {
          loading.clear()
          this.showSuccessTip(rep.msg)
          this.$router.go(-1)
        }).catch(() => {
          loading.clear()
        })
      });
    },
    showHelp(msg) {
      this.$dialog.alert({
        message: msg
      });
    }
  },
  mounted() {
    this.editId = this.$route.query.id;
    checkService('needResign').then(() => {
      this.loadData();
    });
  }
}
</script>

<style>
</style>
